<template>
	<div>
		<NavMenu/>
		<div class="MeetDetailWarp">
			<div class="meetInfoBox">
				<div class="filebox">

					<img :src="srcUrl+MeetDetailObj.titleImgUrl" v-if="MeetDetailObj.titleImgUrl" />
					<img src="@/assets/imgs/home/meetimg.png" v-else />

					<div class="file" v-if="doclist.length!=0">
						<div>附件：</div>
						<div class="fileitem" v-for="(item,index) in doclist" :key="index" @click="downloadDOCfN(item)">
							<img src="@/assets/imgs/home/uploadfileicon.png" />
							<span>
								{{item.name}}
							</span>
						</div>

					</div>
				</div>
				<div class="infobox">
					<div class="namebox">{{MeetDetailObj.confereeName}}</div>

					<div class="otherinfo">
						<div>会议活动编码：{{MeetDetailObj.confereeCode}}</div>
						<div>会议活动起止时间：{{MeetDetailObj.confereeStartTime}}至{{MeetDetailObj.confereeEndTime}}</div>
						<div>会议活动地点：{{MeetDetailObj.confereeSite}}</div>
						<div>发布机构：{{MeetDetailObj.publishOrganization}}</div>
						<div class="endtime">报名截止：{{MeetDetailObj.confereeStartTime | timer}}</div>
					</div>
					<div class="handlebox">
						<div class="confereeQRBox" v-if="MeetDetailObj.isApply==1&&MeetDetailObj.confereeQR">
							<img :src="srcUrl+MeetDetailObj.confereeQR" />
							<div class="text">扫码报名</div>
						</div>
						<div class="applybox" @click="singupFn" v-if="MeetDetailObj.isApply==1">立即报名</div>
						<div v-else class="coursdeadline">
							报名截止
						</div>
						<div class="returnbox" @click="returnFn">返回</div>
						<!-- <div class="codebox" @click="opencodeFn"> <img src="@/assets/imgs/home/meeticon.png" />
							<span>会议二维码</span>
						</div> -->
					</div>
				</div>
			</div>
			<div class="primaryTitle">
				<span class="left-line"></span>
				<span class="title">会议内容</span>
				<span class="right-line"></span>
			</div>
			<div class="centerbox">
				<div class="detail-newscontent">
					<div v-html="MeetDetailObj.confereeContent"></div>
					<!-- <div class="filebox" v-if="doclist.length!=0">
						附件：
						<div v-for="(item,index) in doclist" :key="index" class="file" @click="downloadDOCfN(item)">
							{{item.name}}
						</div>
					</div> -->
				</div>
			</div>
			<!-- <div class="other-news-box">
                <div class="other-news">
                    <div v-if="MeetDetailObj.newsLast" @click="lastNewsFn(MeetDetailObj.newsLast.pressId)">
                        上一篇：{{ MeetDetailObj.newsLast.pressTopic }}
                    </div>
                    <div v-if="MeetDetailObj.newsNext" @click="nextNewsFn(MeetDetailObj.newsNext.pressId)">
                        下一篇：{{ MeetDetailObj.newsNext.pressTopic }}
                    </div>
                </div>
                <div @click="returnPage" class="return-box">【返回列表】</div>
            </div> -->
		</div>
		<Footer/>
		<!-- 会议报名弹框 -->
		<MeetSingupModal :isShow.sync="singupVisible" v-if="singupVisible" :confereeCode='MeetDetailObj.confereeCode' :confereeName='MeetDetailObj.confereeName'
		/>
		<!-- 会议二维码弹框 -->
		<el-dialog title="提示" :visible.sync="codeVisible" width="520px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'>
			<div class="dialogimgbox">
				<img :src="srcUrl+MeetDetailObj.confereeQR" />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="codeVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import MeetSingupModal from "./MeetSingupModal";
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
		NavMenu,
		Footer,
		MeetSingupModal
	},
	data() {
		return {
			srcUrl: srcUrl,
			MeetDetailObj: {},
			singupVisible: false,
			confereeCode: '',
			codeVisible: false,
			doclist: [],
			childMenu: null
		}
	},
	created() {
		let data = JSON.parse(sessionStorage.getItem('childMenuObj'))
		if (data) {
			this.childMenu = data
		}
		else {
			this.childMenu = JSON.parse(sessionStorage.getItem('currentNew'))
		}
	},
	mounted() {
		let id = this.$route.query.id || this.$route.params.id;
		this.getMeetDetail(id);

	},
	methods: {
		async getMeetDetail(id) {
			let data = await httpService.getConferee(id);
			if (data.code == "200") {
				this.MeetDetailObj = data.result;
				if (data.result.downloadAttachment) {
					let doclist = data.result.downloadAttachment.split(",")
					doclist = doclist.map((url, index) => {
						return {
							url: srcUrl + url,
							uid: index,
							name: url,
						}
					})
					this.doclist = doclist
				}
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			} else {
				this.$message.error(data.message);
			}
		},
		singupFn() {
			this.singupVisible = true
			// this.stopScroll()
		},
		returnFn() {
			// if (this.childMenu) {
			// 	this.$router.push(this.childMenu.linkUrl || this.childMenu.menuurl);
			// }
			let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
			let curentMenu = sessionStorage.getItem('clickMenu')
			if (curentMenu == '首页') {
				this.$router.push('/')
			} else {
				if (currentNew) {
					this.$router.push(currentNew.menuurl);
				} else {
					this.$router.push('/meet-secondpage/meetactive')
				}
			}
		},
		opencodeFn() {
			this.codeVisible = true
		},
		downloadDOCfN(data) {
			let Docurl = `${process.env.VUE_APP_GATEWAY}${'/upload/download?session='}${data.name}`
			window.open(Docurl)
		}

	},
	filters: {
		timer: (value) => {
			if (value) {
				return value.substring(0, 10);
			}
		},
	},
}
</script>
<style lang="less" scoped>
.MeetDetailWarp {
	padding: 50px 0 0 0;
	.meetInfoBox {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		.filebox {
			img {
				width: 620px;
				height: 310px;
			}
			.file {
				display: flex;
				flex-direction: column;
				cursor: pointer;
				margin: 20px 0 0 0;
				.fileitem {
					display: flex;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-right: 45px;
					img {
						width: 18px;
						height: 18px;
					}
					span {
						font-size: 16px;
						line-height: 32px;
						color: #bdbdbd;
					}
				}
			}
		}
		.infobox {
			margin-left: 30px;
			.namebox {
				font-size: 22px;
				line-height: 35px;
				color: #333333;
				margin-bottom: 20px;
			}
			.otherinfo {
				color: #666666;
				font-size: 16px;
				line-height: 32px;
				.endtime {
					color: #bdbdbd;
				}
			}
			.handlebox {
				display: flex;
				flex-direction: row;
				font-size: 16px;
				// margin-top: 10px;
				.confereeQRBox {
					img {
						width: 108px;
						height: 108px;
					}
					position: relative;
					.text {
						position: absolute;
						top: 12px;
						right: -67px;
						width: 78px;
						text-align: center;
						height: 23px;
						background: #ffcc51;
						box-shadow: 0px 3px 6px rgba(239, 206, 40, 0.34);
					}
				}
				.applybox {
					width: 160px;
					height: 48px;
					line-height: 48px;
					cursor: pointer;
					text-align: center;
					background: #448df7;
					color: #fff;
					margin: 48px 24px 0 24px;
				}
				.returnbox {
					width: 160px;
					height: 48px;
					line-height: 48px;
					cursor: pointer;
					text-align: center;
					background: #fff;
					border: 1px solid #448df7;
					color: #448df7;
					margin: 48px 0px 0 0px;
				}
				.coursdeadline {
					width: 160px;
					height: 48px;
					line-height: 48px;
					cursor: pointer;
					text-align: center;
					background: #c0c0c0;
					color: #fff;
					cursor: not-allowed;
					margin: 48px 24px 0 0px;
				}
				.codebox {
					width: 183px;
					line-height: 52px;
					text-align: center;
					color: #448df7;
					cursor: pointer;
					height: 52px;
					border: 1px solid #448df7;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					margin-left: 15px;
					img {
						width: 16px;
						height: 16px;
					}
				}
			}
		}
	}
	.detail-newsTitle {
		font-size: 26px;
		font-weight: bold;
		line-height: 35px;
		color: #333333;
		text-align: center;
		position: relative;
		border-bottom: 1px solid #dddddd;
		padding-bottom: 10px;
	}
	.detail-newsTitle::before {
		content: '';
		position: absolute;
		width: 68px;
		height: 0px;
		border: 2px solid #448df7;
		opacity: 1;
		background: #448df7;
		left: 50%;
		transform: translateX(-50%);
		top: 42px;
	}
	.centerbox {
		width: 1000px;
		margin: 0 auto 60px auto;
		.time {
			margin: 20px 0 40px 0;
			line-height: 47px;
			color: #cacaca;
		}
		.detail-newscontent {
			/deep/img {
				width: 100%;
			}
			.filebox {
				font-size: 16px;
				font-weight: bold;
				line-height: 30px;
				margin-top: 40px;
				.file {
					font-size: 16px;
					font-weight: 400;
					// line-height: 30px;
					color: #666;
					cursor: pointer;
					&:hover {
						color: #1088fe;
					}
				}
			}
		}
	}
}
.dialogWarp {
	/deep/.dialogimgbox {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		img {
			width: 200px;
			height: 180px;
		}
	}
}
</style>


